<template>
  <b-modal
    scrollable
    hide-footer
    hide-header
    size='xl'
    id='riskMatrixReportConfigurations'
    ref='riskMatrixReportConfigurations'
    @show='showModal()'
  >
    <b-modal
      header-bg-variant='info'
      header-text-variant='light'
      ref='report'
      id='report'
      scrollable
      hide-footer
      title='Atenção'
    >
      <section class='modal-font-family'>
        <p>
          A impressão do arquivo em Excel está sendo processada,
          clique no botão abaixo para acessar a página de downloads.
        </p>
        <div class="w-100 justify-content-end align-items-center">
          <router-link class='' style='text-decoration: none; float: right' :to="{ name: 'RelatoriosConsultaLegal' }">
            <base-button
              class='btn_export px-4'
            >
              <span class='label'>Acessar</span>
            </base-button>
          </router-link>
        </div>
      </section>
    </b-modal>

    <b-modal
      scrollable
      hide-footer
      hide-header
      size='lg'
      id='print'
      ref='print'
      no-close-on-esc
      no-close-on-backdrop
    >
      <b-overlay
        :show='true'
        rounded
        opacity='0.6'
        spinner-small
        spinner-variant='primary'
        class='d-inline-block w-100'
        style='min-height: 100px'
        variant='light'
      >
        <section class='modal-font-family' v-if='product && product.product && product.product._id'>
          <section style='width: fit-content' :id='product.id' v-if="product.type === 'unit'">
            <section
              v-if='product.unit && product.unit._id'
              class='organization-chart-name-print'
            >
              <span>Unidade: {{ product.unit.name }}</span>

              <section class='line-vertical-bottom'></section>
            </section>

            <section
              v-if='product.sector && product.sector._id'
              class='organization-chart-name-print'
              style='margin-left: 180px;'
            >
              <span>Setor: {{ product.sector.name }}</span>
              <section class='line-vertical-top'></section>

              <section class='line-vertical-bottom'></section>
            </section>

            <section
              v-if='product.sectorRole && product.sectorRole._id'
              class='organization-chart-name-print'
              style='margin-left: 360px;'
            >
              <span>Cargo: {{ product.sectorRole.role.name }} </span>

              <section class='line-vertical-top'></section>

              <section class='line-vertical-bottom'></section>
            </section>

            <section
              v-if='product && product.product && product.product._id'
              class='organization-chart-name-print'
              style='margin-left: 540px;'
            >
              <span>Produto: {{ product.product.name }}</span>

              <section class='line-vertical-top'></section>
            </section>
          </section>

          <section :id='product.id' v-else-if="product.type === 'sector'">
            <section
              v-if='product.sector && product.sector._id'
              class='organization-chart-name-print'
            >
              <span>Setor: {{ product.sector.name }}</span>
              <section class='line-vertical-bottom'></section>
            </section>

            <section
              v-if='product.sectorRole && product.sectorRole._id'
              class='organization-chart-name-print'
              style='margin-left: 180px;'
            >
              <span>Cargo: {{ product.sectorRole.role.name }} </span>

              <section class='line-vertical-top'></section>

              <section class='line-vertical-bottom'></section>
            </section>

            <section
              v-if='product && product.product && product.product._id'
              class='organization-chart-name-print'
              style='margin-left: 360px;'
            >
              <span>Produto: {{ product.product.name }}</span>

              <section class='line-vertical-top'></section>
            </section>
          </section>

          <section :id='product.id' v-else-if="product.type === 'role'">
            <section
              v-if='product.sectorRole && product.sectorRole.role._id'
              class='organization-chart-name-print'
            >
              <span>Cargo: {{ product.sectorRole.role.name }} </span>


              <section class='line-vertical-bottom'></section>
            </section>

            <section
              v-if='product && product.product && product.product._id'
              class='organization-chart-name-print'
              style='margin-left: 180px;'
            >
              <span>Produto: {{ product.product.name }}</span>

              <section class='line-vertical-top'></section>
            </section>
          </section>

          <section :id='product.id' v-else>
            <section
              v-if='product && product.product && product.product._id'
              class='organization-chart-name-print'
            >
              <span>Produto: {{ product.product.name }}</span>
            </section>
          </section>
        </section>

        <template v-slot:overlay class='w-100'>
          <div class='text-center w-100'>
            <b-spinner
              style='width: 2rem; height: 2rem'
              variant='primary'
              label='Large Spinner'
            ></b-spinner>
            <p style='font-size: 18px' class='text-primary'><strong>Gerando hierarquia do produto:
              {{ product && product.product && product.product.name ? product.product.name : '-' }}</strong></p>
          </div>
        </template>
      </b-overlay>
    </b-modal>

    <b-modal
      scrollable
      hide-footer
      hide-header
      size='xl'
      id='methodologySettings'
      ref='methodologySettings'
    >
      <section class='modal-font-family'>
        <section class='mb-3 d-flex align-content-center justify-content-between header'>
          <section>
            <p class='title mt-1'>
              Configurações de metodologia HO Fácil Web e Complementares
            </p>
          </section>

          <section>
            <b-icon
              style='cursor: pointer'
              @click='closeMethodologySettings()'
              class='ml-1'
              font-scale='2.3'
              icon='x'
              color='#262626'
            >
            </b-icon>
          </section>
        </section>

        <section class='alert_ d-flex align-items-center p-2'>
          <svg width='30' height='30' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
              d='M9 15H11V9H9V15ZM10 7C10.2833 7 10.521 6.904 10.713 6.712C10.905 6.52 11.0007 6.28267 11 6C11 5.71667 10.904 5.479 10.712 5.287C10.52 5.095 10.2827 4.99933 10 5C9.71667 5 9.479 5.096 9.287 5.288C9.095 5.48 8.99933 5.71733 9 6C9 6.28333 9.096 6.521 9.288 6.713C9.48 6.905 9.71733 7.00067 10 7ZM10 20C8.61667 20 7.31667 19.7373 6.1 19.212C4.88333 18.6867 3.825 17.9743 2.925 17.075C2.025 16.175 1.31267 15.1167 0.788 13.9C0.263333 12.6833 0.000666667 11.3833 0 10C0 8.61667 0.262667 7.31667 0.788 6.1C1.31333 4.88333 2.02567 3.825 2.925 2.925C3.825 2.025 4.88333 1.31267 6.1 0.788C7.31667 0.263333 8.61667 0.000666667 10 0C11.3833 0 12.6833 0.262667 13.9 0.788C15.1167 1.31333 16.175 2.02567 17.075 2.925C17.975 3.825 18.6877 4.88333 19.213 6.1C19.7383 7.31667 20.0007 8.61667 20 10C20 11.3833 19.7373 12.6833 19.212 13.9C18.6867 15.1167 17.9743 16.175 17.075 17.075C16.175 17.975 15.1167 18.6877 13.9 19.213C12.6833 19.7383 11.3833 20.0007 10 20Z'
              fill='#022245' />
          </svg>

          <p class='p-0 m-0 ml-3'>
            Qualquer uma das metodologias será composta por introdução e memorial, estes são opcionais devido ao seu
            tamanho.
            A metodologia padrão e obrigatória é a HFW (HO Fácil Web), selecionar a CB ou VHR complementa e melhora o
            resultado.
          </p>
        </section>

        <section class='mt-4  pa-2'>
          <p class='sub-title   mb-2'>Selecione a metodologia a ser impressa</p>
          <!--<span class='sub-title-information'>A metodologia HFW é obrigatória. </span> <br/>-->
          <span
            class='sub-title-information'>As outras opções podem ser selecionadas para complementar o resultado.</span>
        </section>

        <section class='mt-4'>
          <section style='display: grid;  grid-template-columns: repeat(auto-fill, minmax(33.33%, auto));'>
            <section
              class='p-2 mr-3 methodology-not-selected'
              style="opacity: .6"
            >
              <strong><em class='methodology-title'>(Disponível em breve)</em></strong>
              <p class='not-selected'>Metodologia HFW </p>
              <hr />

              <b-form-checkbox
                id='addDescriptionMethodologyHFW'
                name='addDescriptionMethodologyHFW'
                v-model='addDescriptionMethodologyHFW'
                disabled
                class=''
              >
                <span
                  :class="addDescriptionMethodologyHFW ? 'selected' : 'not-selected'"
                >
                  Adicionar descrição da metodologia
                </span>
              </b-form-checkbox>

              <b-form-checkbox
                id='memorialCalculationMethodologyHFW'
                name='memorialCalculationMethodologyHFW'
                disabled
                class='mt-2'
                v-model='memorialCalculationMethodologyHFW'
              >
              <span class='not-selected'>
                Memorial de cálculo <em>(sempre impresso por padrão)</em>
              </span>
              </b-form-checkbox>
            </section>

            <section
              v-if='methodology === 1'
              class='p-2 mr-3'
              :class="addMethodologyDescriptionCB || addCalculationMemorialCB ? 'methodology-selected': 'methodology-not-selected'"
            >
              <p
                class='methodology-title'
                :style="addMethodologyDescriptionCB || addCalculationMemorialCB ? 'color: #022245;': 'color: #262626;'"
              >
                Metodologia CB (control banding)
              </p>

              <hr />
              <b-form-checkbox
                id='addMethodologyDescriptionCB'
                name='addMethodologyDescriptionCB'
                v-model='addMethodologyDescriptionCB'
              >
              <span
                :class="addMethodologyDescriptionCB ? 'selected' : 'not-selected'"
              >
                Adicionar descrição da metodologia
              </span>
              </b-form-checkbox>

              <b-form-checkbox
                id='addCalculationMemorialCB'
                name='addCalculationMemorialCB'
                v-model='addCalculationMemorialCB'
                class='mt-2'
              >
                <span
                  :class="addCalculationMemorialCB ? 'selected' : 'not-selected'"
                >
                  Adicionar memorial de cálculo
                </span>
              </b-form-checkbox>
            </section>

            <section
              v-if='methodology === 1'
              class='p-2 mr-3'
              :class="addMethodologyDescriptionVHR || addCalculationMemorialVHR ? 'methodology-selected': 'methodology-not-selected'"
            >
              <p
                class='methodology-title'
                :style="addMethodologyDescriptionVHR || addCalculationMemorialVHR ? 'color: #022245;': 'color: #262626;'"
              >
                Metodologia VHR
              </p>

              <hr />
              <b-form-checkbox
                id='addMethodologyDescriptionVHR'
                name='addMethodologyDescriptionVHR'
                v-model='addMethodologyDescriptionVHR'
              >
              <span
                :class="addMethodologyDescriptionVHR ? 'selected' : 'not-selected'"
              >
                Adicionar descrição da metodologia
              </span>
              </b-form-checkbox>

              <b-form-checkbox
                id='addCalculationMemorialVHR'
                name='addCalculationMemorialVHR'
                v-model='addCalculationMemorialVHR'
                class='mt-2'
              >
                <span
                  :class="addCalculationMemorialVHR ? 'selected' : 'not-selected'"
                >
                  Adicionar memorial de cálculo
                </span>
              </b-form-checkbox>
            </section>
          </section>
        </section>

        <section class='mt-5'>
          <hr />
        </section>

        <section class='number-of-pages p-2 mt-4'>
          <p class='mb-0'>Seu documento irá ter aproximadamente <strong>{{ numberOfPages }} páginas</strong> com as
            configurações escolhidas.</p>
        </section>

        <section class='mt-4 mb-3 d-flex'>
          <button @click='closeMethodologySettings()' class='btn-cancel w-25 mr-2'>
            <span>Cancelar</span>
          </button>

          <button @click='confirmSettings()' class='btn-confirm w-75'>
            <span>Confirmar configurações</span>
          </button>
        </section>
      </section>
    </b-modal>

    <section class='modal-font-family'>
      <section class='d-flex align-content-center justify-content-between header'>
        <section>
          <p class='title mt-1'>
            Selecionar hierarquia para gerar relatório
          </p>
        </section>

        <section>
          <b-icon
            style='cursor: pointer'
            @click='closeModal()'
            class='ml-1'
            font-scale='2.3'
            icon='x'
            color='#262626'
          >
          </b-icon>
        </section>
      </section>

      <section>
        <hr />
      </section>

      <section class='sub-header mt-4 d-flex align-items-start justify-content-between'>
        <section>
          <p class='m-0'>A partir de qual parte da hierarquia você quer gerar o relatório?</p>
          <span>Clique em um dos cards da hierarquia abaixo para selecionar</span>
        </section>

        <section>
          <section class='d-flex align-items-center justify-content-end' style='right: 0; top: 0'>
            <b-button
              variant='outline-success'
              @click='zoom -= .1'
              class='d-flex align-items-center justify-content-end'
            >
              <b-icon
                icon='zoom-out'
                aria-hidden='true'>
              </b-icon>
            </b-button>

            <b-button
              variant='outline-success'
              class='ml-2 d-flex align-items-center justify-content-end'
              @click='zoom += .1'
            >
              <b-icon
                icon='zoom-in'
                aria-hidden='true'>
              </b-icon>
            </b-button>
          </section>
        </section>
      </section>

      <ul class='mt-1 w-100' v-if='companyProps && companyProps.length > 0'>
        <li
          class='organization-chart'
          v-for='(company, i) in companyProps'
          :key='company._id'
        >
          <section class='tree'>
            <section class='scroll'>
              <ul
                class='mb-4'
                :style='`zoom: ${zoom};width: fit-content; -transition: all 0.5s;`'
                v-if='company.units && company.units.length > 0'
              >
                <li
                  v-for='unit in company.units'
                  :key='unit._id'
                  :class="hierarchy && hierarchy._id === unit._id ? 'selected-hierarchy' : ''"
                >
                  <a
                    @click="setHierarchy(unit, 'unit')"
                  >
                    <section class='organization-chart-name'>
                      <span>Unidade: {{ unit.name }}</span>
                    </section>
                  </a>

                  <ul v-if='unit.sectors && unit.sectors.length > 0'>
                    <li
                      v-for='sector in unit.sectors'
                      :key='sector._id'
                      :class="hierarchy && hierarchy._id === sector._id ? 'selected-hierarchy' : ''"
                    >
                      <a
                        @click="setHierarchy(sector, 'sector')"
                      >
                        <section class='organization-chart-name'>
                          <span>Setor: {{ sector.name }}</span>
                        </section>
                      </a>

                      <ul v-if='sector.sectorRoles && sector.sectorRoles.length > 0'>
                        <li
                          v-for='sectorRole in sector.sectorRoles'
                          :key='sectorRole._id'
                          v-show='sectorRole && sectorRole.role &&
                                  sectorRole.role.roleProductsLegalConsultation &&
                                  sectorRole.role.roleProductsLegalConsultation.length > 0 &&
                                  sectorRole.role.roleProductsLegalConsultation.filter(x => x.product && x.product._id).length > 0'
                          :class="hierarchy && hierarchy._id === sectorRole._id ? 'selected-hierarchy' : ''"
                        >
                          <a
                            @click="setHierarchy(sectorRole, 'role')"
                          >
                            <section class='organization-chart-name'>
                              <span> Cargo: {{ sectorRole.role.name }}</span>
                            </section>
                          </a>

                          <ul v-if='sectorRole && sectorRole.role &&
                                  sectorRole.role.roleProductsLegalConsultation &&
                                  sectorRole.role.roleProductsLegalConsultation.length > 0 &&
                                  sectorRole.role.roleProductsLegalConsultation.filter(x => x.product && x.product._id).length > 0'>
                            <li
                              v-for='roleProductLegalConsultation in sectorRole.role.roleProductsLegalConsultation.filter(x => x.product && x.product._id)'
                              :key='roleProductLegalConsultation._id'
                              :class="hierarchy && hierarchy._id === roleProductLegalConsultation.product._id ? 'selected-hierarchy' : ''"
                            >
                              <a
                                @click="setHierarchy(roleProductLegalConsultation.product, 'product')"
                              >
                                <section class='organization-chart-name'>
                                  <span> Produto: {{ roleProductLegalConsultation.product.name }}</span>
                                </section>
                              </a>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </section>
          </section>
        </li>
      </ul>

      <section>
        <b-alert
          show
          variant='danger'
          :class='{ hidden: !error }'
        >
          {{ error }}
        </b-alert>
      </section>
      <section class='methodology'>
        <label for='methodology' class='label'>Selecione a metodologia</label>
        <section class='d-flex justify-content-between'>
          <b-form-select
            id='methodology'
            v-model='methodology'
            :options='methodologies'
            class='mb-1  '
            style='height: 40px; border: 1px solid #808080'
            value-field='key'
            text-field='value'
            @change='resetMethodologySettings'
          >
            <template #first>
              <b-form-select-option
                :value='null'
                disabled
              >
                Selecione a metodologia
              </b-form-select-option>
            </template>
          </b-form-select>

          <button
            @click='showMethodologySettings()'
            class='gear position-relative ml-3'
            :class="filledInMethodologySettings ? '': 'pulse'"
            :style="filledInMethodologySettings ? 'border-color: #ced4da': 'border-radius: 0.25rem; border-color:#FF0000; background-color: transparent;box-shadow: 0 0 0 0 #FF0000'"
          >
            <svg width='24' height='24' viewBox='0 0 24 24' :fill="filledInMethodologySettings ? '#262626': '#FF0000'"
                 xmlns='http://www.w3.org/2000/svg'>
              <path
                d='M11.9987 8C13.0595 8 14.077 8.42143 14.8271 9.17157C15.5772 9.92172 15.9987 10.9391 15.9987 12C15.9987 13.0609 15.5772 14.0783 14.8271 14.8284C14.077 15.5786 13.0595 16 11.9987 16C10.9378 16 9.92039 15.5786 9.17024 14.8284C8.4201 14.0783 7.99867 13.0609 7.99867 12C7.99867 10.9391 8.4201 9.92172 9.17024 9.17157C9.92039 8.42143 10.9378 8 11.9987 8ZM11.9987 10C11.4682 10 10.9595 10.2107 10.5845 10.5858C10.2094 10.9609 9.99867 11.4696 9.99867 12C9.99867 12.5304 10.2094 13.0391 10.5845 13.4142C10.9595 13.7893 11.4682 14 11.9987 14C12.5291 14 13.0378 13.7893 13.4129 13.4142C13.788 13.0391 13.9987 12.5304 13.9987 12C13.9987 11.4696 13.788 10.9609 13.4129 10.5858C13.0378 10.2107 12.5291 10 11.9987 10ZM9.99867 22C9.74867 22 9.53867 21.82 9.49867 21.58L9.12867 18.93C8.49867 18.68 7.95867 18.34 7.43867 17.94L4.94867 18.95C4.72867 19.03 4.45867 18.95 4.33867 18.73L2.33867 15.27C2.27747 15.167 2.25589 15.0452 2.27798 14.9274C2.30006 14.8096 2.3643 14.7039 2.45867 14.63L4.56867 12.97L4.49867 12L4.56867 11L2.45867 9.37C2.3643 9.29613 2.30006 9.19042 2.27798 9.07263C2.25589 8.95484 2.27747 8.83304 2.33867 8.73L4.33867 5.27C4.45867 5.05 4.72867 4.96 4.94867 5.05L7.43867 6.05C7.95867 5.66 8.49867 5.32 9.12867 5.07L9.49867 2.42C9.53867 2.18 9.74867 2 9.99867 2H13.9987C14.2487 2 14.4587 2.18 14.4987 2.42L14.8687 5.07C15.4987 5.32 16.0387 5.66 16.5587 6.05L19.0487 5.05C19.2687 4.96 19.5387 5.05 19.6587 5.27L21.6587 8.73C21.7887 8.95 21.7287 9.22 21.5387 9.37L19.4287 11L19.4987 12L19.4287 13L21.5387 14.63C21.7287 14.78 21.7887 15.05 21.6587 15.27L19.6587 18.73C19.5387 18.95 19.2687 19.04 19.0487 18.95L16.5587 17.95C16.0387 18.34 15.4987 18.68 14.8687 18.93L14.4987 21.58C14.4587 21.82 14.2487 22 13.9987 22H9.99867ZM11.2487 4L10.8787 6.61C9.67867 6.86 8.61867 7.5 7.84867 8.39L5.43867 7.35L4.68867 8.65L6.79867 10.2C6.39867 11.3667 6.39867 12.6333 6.79867 13.8L4.67867 15.36L5.42867 16.66L7.85867 15.62C8.62867 16.5 9.67867 17.14 10.8687 17.38L11.2387 20H12.7587L13.1287 17.39C14.3187 17.14 15.3687 16.5 16.1387 15.62L18.5687 16.66L19.3187 15.36L17.1987 13.81C17.5987 12.64 17.5987 11.37 17.1987 10.2L19.3087 8.65L18.5587 7.35L16.1487 8.39C15.3629 7.48032 14.297 6.85767 13.1187 6.62L12.7487 4H11.2487Z'
                :fill="filledInMethodologySettings ? '#262626': '#FF0000'" />
            </svg>

            <section v-if='filledInMethodologySettings' class='position-absolute checkMethodology'>
              <img
                width='100%'
                height='100%'
                src='@/assets/images/checkMethodology.svg'
                class='p-0'
                alt='Preenchido'
              />
            </section>
          </button>
        </section>
        <span v-if='methodology'>Esta opção requer configurações extras. Para acessá-las, clique no botão da engrenagem.</span>
      </section>

      <section class='mt-4 mb-3'>

        <b-overlay
          :show='exporting'
          rounded
          opacity='0.6'
          spinner-small
          spinner-variant='primary'
          class='d-inline-block w-100'
          variant='light'
        >
          <button
            :class="completedAllTheOptions ? 'btn-confirm w-100' : 'pulse w-100'"
            style='border: none'
            @click='validateSelectedSettings()'
          >
            <span v-if='completedAllTheOptions'>Gerar relatório</span>
            <span v-else>
                <span
                  v-if='methodology === 1'>Para prosseguir com a geração de relatório, clique no botão da engrenagem</span>
                <span v-else>Gerar relatório</span>
              </span>
          </button>
        </b-overlay>
      </section>
    </section>

  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import api from '@/utils/api'
import axios from 'axios'
import { Buffer } from 'buffer'

export default {
  name: 'RiskMatrixReportConfigurations',
  components: {},
  props: {
    companyProps: { type: Array, default: Array }
  },
  data() {
    return {
      zoom: 1,
      products: [],
      loading: false,
      product: null,
      hierarchyType: null,
      hierarchy: null,
      memorialCalculationMethodologyHFW: false,
      addDescriptionMethodologyHFW: false,
      addMethodologyDescriptionCB: false,
      addCalculationMemorialCB: false,
      addMethodologyDescriptionVHR: false,
      addCalculationMemorialVHR: false,
      confirmedSelectedSettings: false,
      methodology: null,
      methodologies: [
        {
          key: 1,
          value: 'Control banding e VHR'
        },
        /*{
          key: 2,
          value: 'Somente HO Fácil Web'
        }*/
      ]
    }
  },
  computed: {
    ...mapGetters('companyLegalConsultation', {
      companiesReportMeta: 'companiesReportMeta',
      companiesReport: 'companiesReport'
    }),
    user() {
      return this.$store.getters['user/current']
    },
    error() {
      return this.$store.getters['access/error']
    },
    message() {
      return this.$store.getters['access/message']
    },
    exporting() {
      return this.$store.getters['legalSearch/exporting']
    },
    filledInMethodologySettings() {
      return this.confirmedSelectedSettings
    },
    completedAllTheOptions() {
      return !!(this.methodology && this.filledInMethodologySettings)
    },
    numberOfPages() {
      let numberPages = 0
      if (this.memorialCalculationMethodologyHFW){
        numberPages += 2;
      }
      if (this.addDescriptionMethodologyHFW){
        numberPages += 10;
      }
      if (this.addMethodologyDescriptionCB){
        numberPages += 10;
      }
      if (this.addCalculationMemorialCB){
        numberPages += 2;
      }
      if (this.addMethodologyDescriptionVHR){
        numberPages += 4;
      }
      if (this.addCalculationMemorialVHR){
        numberPages += 2;
      }
      return numberPages
    }
  },
  methods: {
    ...mapActions('companyLegalConsultation', {
      handlePaginationReportCompanyLegalConsultation: 'handlePaginationReportCompanyLegalConsultation',
      resetCompanyLegalConsultationMetaReport: 'resetCompanyLegalConsultationMetaReport',
      handleMatrizRisco: 'handleMatrizRisco'
    }),
    ...mapActions('reportsDownloads', {
      handleCreateReportDownloads: 'handleCreateReportDownloads'
    }),
    ...mapActions('legalSearch', {
      exportingExcel: 'exportingExcel'
    }),
    setHierarchy(hierarchy, type) {
      if (this.hierarchy && this.hierarchy._id && this.hierarchy._id === hierarchy._id) {
        this.hierarchy = null
      } else {
        this.hierarchy = hierarchy
        this.hierarchy.type = type
      }
      this.resetAlert()
      this.products = []
      this.hierarchyType = type
      if (hierarchy && hierarchy._id) {
        switch (hierarchy.type) {
          case 'unit': {
            hierarchy.sectors.forEach((sector) => {
              if(sector.sectorRoles && sector.sectorRoles.length > 0) {
                sector.sectorRoles.forEach((sectorRole) => {
                  if(sectorRole && sectorRole.role &&
                    sectorRole.role.roleProductsLegalConsultation &&
                    sectorRole.role.roleProductsLegalConsultation.length > 0 &&
                    sectorRole.role.roleProductsLegalConsultation.filter(x => x.product && x.product._id).length > 0)
                  {
                    sectorRole.role.roleProductsLegalConsultation.filter(x => x.product && x.product._id).forEach((roleProductLegalConsultation) => {
                      this.products.push({
                        id: `${hierarchy._id}_${roleProductLegalConsultation.product._id}`,
                        type,
                        unit: hierarchy,
                        sector,
                        sectorRole,
                        product: roleProductLegalConsultation.product
                      })
                    })
                  }
                })
              }
            })
            break
          }
          case 'sector': {
            if(hierarchy.sectorRoles && hierarchy.sectorRoles.length > 0) {
              hierarchy.sectorRoles.forEach((sectorRole) => {
                if(sectorRole && sectorRole.role &&
                  sectorRole.role.roleProductsLegalConsultation &&
                  sectorRole.role.roleProductsLegalConsultation.length > 0 &&
                  sectorRole.role.roleProductsLegalConsultation.filter(x => x.product && x.product._id).length > 0) {
                  sectorRole.role.roleProductsLegalConsultation.filter(x => x.product && x.product._id).forEach((roleProductLegalConsultation) => {
                    this.products.push({
                      id: `${hierarchy._id}_${roleProductLegalConsultation.product._id}`,
                      type,
                      sector: hierarchy,
                      sectorRole,
                      product: roleProductLegalConsultation.product
                    })
                  })
                }
              })
            }
            break
          }
          case 'role': {
            if(hierarchy && hierarchy.role &&
              hierarchy.role.roleProductsLegalConsultation &&
              hierarchy.role.roleProductsLegalConsultation.length > 0 &&
              hierarchy.role.roleProductsLegalConsultation.filter(x => x.product && x.product._id).length > 0)
            {
              hierarchy.role.roleProductsLegalConsultation.filter(x => x.product && x.product._id).forEach((roleProductLegalConsultation) => {
                this.products.push({
                  id: `${hierarchy._id}_${roleProductLegalConsultation.product._id}`,
                  type,
                  sectorRole: hierarchy,
                  product: roleProductLegalConsultation.product
                })
              })
            }
            break
          }
          default: {
            this.products.push(
              {
                id: `${hierarchy._id}_${hierarchy._id}`,
                type,
                product: hierarchy
              })
            break
          }
        }
      }

    },

    closeModal() {
      this.$bvModal.hide('riskMatrixReportConfigurations')
    },

    showModal() {
      this.hierarchy = null
      this.methodology = null
      this.resetMethodologySettings()
      this.resetAlert()

    },

    resetMethodologySettings() {
      this.memorialCalculationMethodologyHFW = false;
      this.addDescriptionMethodologyHFW = false;
      this.addMethodologyDescriptionCB = false;
      this.addCalculationMemorialCB = false;
      this.addMethodologyDescriptionVHR = false;
      this.addCalculationMemorialVHR = false;
      this.confirmedSelectedSettings = false;
      this.resetAlert()
    },

    showMethodologySettings() {
      this.resetAlert()
      if(!this.methodology){
        this.$store.dispatch('access/updateError', 'Selecione a metodologia')
        return
      }
      this.$bvModal.show('methodologySettings')
    },

    confirmSettings(){
      this.closeMethodologySettings();
      this.confirmedSelectedSettings = true;
    },

    closeMethodologySettings() {
      this.$bvModal.hide('methodologySettings')
    },

    validateSelectedSettings() {
      try {
        this.resetAlert()
        if (!this.completedAllTheOptions) {
          this.$store.dispatch('access/updateError', 'Preencha os campos solicitados')
          return
        }
        this.$store.dispatch('access/updateMessage', 'Ok')
        this.saveAsPNG()
      } catch (e) {

      }
    },

    resetAlert() {
      this.$store.dispatch('access/updateError', '')
      this.$store.dispatch('access/updateMessage', '')
    },

    selectWholeHierarchy(){
      try {
        for (const company of this.companyProps) {
          for (const unit of company.units) {
            for (const sector of unit.sectors) {
              if(sector.sectorRoles && sector.sectorRoles.length > 0) {
                for (const sectorRole of sector.sectorRoles) {
                  if(sectorRole && sectorRole.role &&
                    sectorRole.role.roleProductsLegalConsultation &&
                    sectorRole.role.roleProductsLegalConsultation.length > 0 &&
                    sectorRole.role.roleProductsLegalConsultation.filter(x => x.product && x.product._id).length > 0) {
                    for (const roleProductLegalConsultation of sectorRole.role.roleProductsLegalConsultation.filter(x => x.product && x.product._id)) {
                      this.products.push({
                        id: `${unit._id}_${roleProductLegalConsultation.product._id}`,
                        type: 'unit',
                        unit,
                        sector,
                        sectorRole,
                        product: roleProductLegalConsultation.product
                      })
                    }
                  }
                }
              }
            }
          }
        }
      } catch (e) {

      }
    },

    async saveAsPNG() {
      try {
        if (!this.hierarchy || !this.hierarchy._id) {
          this.products = []
          this.selectWholeHierarchy()
        }
        this.loading = true
        this.product = this.products[0]
        const productsLength = this.products.length
        for (let i = 0; i < productsLength; i++) {
          this.product = this.products[i];
          switch (this.product.type) {
            case 'unit': {
              const {unit, sector, sectorRole, product} = this.product
              const {name: nameUnit } = unit
              const {name: nameSector } = sector
              const {role } = sectorRole
              const {name: nameRole } = role
              const {name: nameProduct } = product
              this.products[i].hierarchy = {
                type: this.product.type,
                unit: nameUnit,
                sector: nameSector,
                role: nameRole,
                product: nameProduct,
              }
              break
            }
            case 'sector': {
              const {sector, sectorRole, product} = this.product
              const {name: nameSector } = sector
              const {role } = sectorRole
              const {name: nameRole } = role
              const {name: nameProduct } = product
              this.products[i].hierarchy = {
                type: this.product.type,
                sector: nameSector,
                role: nameRole,
                product: nameProduct,
              }
              break
            }
            case 'role': {
              const {sectorRole, product} = this.product
              const {role } = sectorRole
              const {name: nameRole } = role
              const {name: nameProduct } = product
              this.products[i].hierarchy = {
                type: this.product.type,
                role: nameRole,
                product: nameProduct,
              }
              break
            }
            default: {
              const {product} = this.product
              const {name: nameProduct } = product
              this.products[i].hierarchy = {
                type: this.product.type,
                product: nameProduct,
              }
              break
            }
          }
          console.log(`this.products[i].hierarchy: ${this.products[i].hierarchy}`)
          //console.log(this.product)
        }
        await this.generateReport()
        this.loading = false
      } catch (e) {
        console.error(e)
      }
    },
    async upload(base64) {
      try {
        const { data, status } = await api.post('uploads/base64', {
          fileType: 'image/png',
          base64
        })
        if(status == 200 && data.url){
          return data.url
        }
        return null
      } catch (e) {
        return null
      }
    },
    async generateReport() {
      try {
        this.$bvModal.hide('print')
        const hierarchies = this.products.map((product) => {
          return {
            type: product.type,
            unitId: product.unit && product.unit._id ? product.unit._id : null,
            sectorId: product.sector && product.sector._id ? product.sector._id : null,
            sectorRoleId: product.sectorRole && product.sectorRole._id ? product.sectorRole._id : null,
            roleId: product.sectorRole && product.sectorRole.role && product.sectorRole.role._id ? product.sectorRole.role._id : null,
            //roleProductLegalConsultationId: product.roleProductLegalConsultation && product.roleProductLegalConsultation._id ? product.roleProductLegalConsultation._id : null,
            productId: product && product.product && product.product._id? product.product._id : null,
            imageHierarchyBaseb4: product.imageBase64,
            hierarchy: product.hierarchy,
          }
        })
        const body = {
          memorialCalculationMethodologyHFW: this.memorialCalculationMethodologyHFW,
          addDescriptionMethodologyHFW: this.addDescriptionMethodologyHFW,
          addMethodologyDescriptionCB: this.addMethodologyDescriptionCB,
          keyFileMethodologyDescriptionCB: this.addMethodologyDescriptionCB ? '1721652052219': null,
          addCalculationMemorialCB: this.addCalculationMemorialCB,
          addMethodologyDescriptionVHR: this.addMethodologyDescriptionVHR,
          keyFileMethodologyDescriptionVHR: this.addMethodologyDescriptionVHR ? '1721651595225': null,
          addCalculationMemorialVHR: this.addCalculationMemorialVHR,
          userId: this.user.id,
          companyId: this.companyProps[0]._id,
          hierarchies,
        }
        /*await this.exportingExcel(true)
        const { data } = await this.handleMatrizRisco(body)
        const { url } = data
        window.open(url, '_blank')
        await this.exportingExcel(false)*/

        await this.exportingExcel(true)
        const payload = {
          user: this.user.id,
          type: 'companyReport',
          format: 'pdf',
          job: 'companyReport',
          parameters: {
            ...body
          }
        }

        const { data, status } = await this.handleCreateReportDownloads(payload)

        let message = data.message
        let variant = 'danger'

        await this.exportingExcel(false)

        if (status === 201) {
          message = data.message
          variant = 'success'
          this.$refs['report'].show()
          return
        }

        this.$bvToast.toast(message, {
          title: 'Atenção',
          variant: variant,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })
      } catch (e) {

      }
    }
  },
  async mounted() {

  },
  async created() {
  },
  watch: {}
}
</script>

<style lang='scss' scoped>
.scroll {
  overflow: auto !important;
  text-align: center !important;

  &::-webkit-scrollbar {
    width: 30px;
  }

  &::-webkit-scrollbar-track {
    background: #ffffff;
  }

  &::-webkit-scrollbar-thumb {
    background: #022245;
    border-radius: 20px;
    border: 3px solid #ffffff;
    -webkit-box-shadow: inset 0 0 6px #022245;
  }
}

hr {
  background: #C0C0C0;
}

.header {
  .title {
    font-size: 20px;
    font-weight: 700;
    line-height: 29.26px;
    text-align: left;
    color: #262626;

  }
}

.sub-header {
  p {
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    text-align: left;
    color: #262626;
  }

  span {
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    text-align: left;
    color: #808080;

  }
}

.methodology {
  .label {
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    text-align: left;
    color: #262626;
  }

  span {
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    text-align: left;
    color: #808080;
  }
}

.methodology-selected {
  border: 1px solid #022245;
  border-radius: 5px;
}

.methodology-not-selected {
  border: 1px solid #D9D9D9;
  border-radius: 5px;
}
.selected {
  font-size: 14px;
  font-weight: 700;
  line-height: 24px;
  text-align: left;
  color: #022245;

  a {
    text-decoration: underline;
  }
}

.not-selected {
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  color: #262626;

  a {
    text-decoration: underline;
  }
}

.methodology-title {
  font-size: 15px;
  font-weight: 700;
  line-height: 24px;
  text-align: left;
  color: #022245;
  em {
    font-size: 13px;
  }
}


.gear {
  background: transparent;
  height: 40px;
  width: 40px;
  border-radius: 0.25rem;
  border-width: 1px;
  border-style: solid;
  border-color: #808080;

  .checkMethodology {
    padding: 0;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: #FFFFFF;
    bottom: -8px;
    right: -10px;

  }
}

.alert_ {
  border: 1px solid #04A8F366;
  border-radius: 8px;
  background: #04A8F366;

  p {
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    text-align: left;
    color: #022245;
  }
}

.label-radio {
  font-size: 16px;
  font-weight: 700;
  line-height: 19.5px;
  letter-spacing: 0.02em;
  text-align: left;
  color: #262626;

}

.item-radio {
  font-size: 14px;
  line-height: 24px;
}

.btn-cancel {
  text-align: center;
  border: 1px solid #022245;
  background: transparent;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  color: #022245;
  height: 40px;
  border-radius: 6.25px;
}

.btn-confirm {
  text-align: center;
  background: #022245;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  color: #FFFFFF;
  height: 40px;
  border-radius: 6.25px;
}

.number-of-pages {
  background: #CBD63E;
  border-radius: 6px;
  font-size: 20px;
  font-weight: 400;
  line-height: 24px;
  text-align: center;
  color: #022245;

}

.tree ul {
  padding-top: 20px;
  position: relative;
  -transition: all 0.5s;
  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
  display: flex;
  //justify-content: center;
  flex-wrap: nowrap;
}

.tree li {
  float: left;
  text-align: center;
  list-style-type: none;
  position: relative;
  padding: 20px 5px 0 5px;
  -transition: all 0.5s;
  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
}

.tree li::before,
.tree li::after {
  content: '';
  position: absolute;
  top: 0;
  right: 50%;
  border-top: 1.5px solid #696969;
  width: 50%;
  height: 20px;
}

.tree li::after {
  right: auto;
  left: 50%;
  border-left: 1.5px solid #808080;
}

.tree li:only-child::after,
.tree li:only-child::before {
  display: none;
}

.tree li:only-child {
  padding-top: 0;
}

.tree li:first-child::before,
.tree li:last-child::after {
  border: 0 none;
}

.tree li:last-child::before {
  border-right: 1.5px solid #808080;
  border-radius: 0 5px 0 0;
  -webkit-border-radius: 0 5px 0 0;
  -moz-border-radius: 0 5px 0 0;
}

.tree li:first-child::after {
  border-radius: 5px 0 0 0;
  -webkit-border-radius: 5px 0 0 0;
  -moz-border-radius: 5px 0 0 0;
}

.tree ul ul::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  border-left: 1.5px solid #808080;
  width: 0;
  height: 20px;
}

.tree li a {
  text-decoration: none;
  color: #262626;
  font-size: 14px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: center !important;
  display: inline-block;
  border-radius: 6px;
  border: 1.5px solid #808080;
  -transition: all 0.5s;
  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
}

.tree li a:hover,
.tree li a:hover + ul li a {
  background: var(--navy-blue);
  color: #FFFFFF;
}

.selected-hierarchy a,
.selected-hierarchy a + ul li a {
  background: var(--navy-blue);
  color: #FFFFFF !important;
}

.tree li a:hover + ul li::after,
.tree li a:hover + ul li::before,
.tree li a:hover + ul::before,
.tree li a:hover + ul ul::before {
  border-color: #94a0b4;
}


.organization-chart {
  overflow: auto;
  //border: 1px solid #808080;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.organization-chart-title {
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0em;
  color: #262626;
}

.organization-chart-text-company-structure {
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.02em;
  text-align: left;
  color: #808080;
}

.btn-reports-disabled {
  border-radius: 4px;
  background: #BDBDBD;
  border: none;
  padding: 8px 10px;
  color: #FFFFFF;
  font-weight: 700;
  line-height: 17px;
  letter-spacing: 0em;
  margin-right: 20px;
}

.available-soon {
  background: #DBECF4;
  border-radius: 20px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0em;
  color: var(--navy-blue);
  padding: 10px 15px;
}

.organization-chart-sub-title {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  color: #262626;
}

.organization-chart-name {
  min-height: 60px;
  min-width: 200px;
  max-width: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 7px;
  word-break: break-word;
  cursor: pointer;
}

.sub-title {
  font-size: 16px;
  font-weight: 700;
  line-height: 19.5px;
  letter-spacing: 0.02em;
  text-align: left;
  color: #262626;
}

.sub-title-information {
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
  color: #808080;
}

.pulse {
  border: 1px solid #FF0000;
  -webkit-animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
  -moz-animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
  -ms-animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
  animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
  background-color: #808080;
  box-shadow: 0 0 0 0 #808080;
  color: var(--white);
  font-weight: 600;
  font-size: 18px;
  height: 40px;
  border-radius: 8px;

  &:hover {
    -webkit-animation: none;
    -moz-animation: none;
    -ms-animation: none;
    animation: none;
  }
}

@-webkit-keyframes pulse {
  to {
    box-shadow: 0 0 0 8px rgba(232, 76, 61, 0);
  }
}

@-moz-keyframes pulse {
  to {
    box-shadow: 0 0 0 8px rgba(232, 76, 61, 0);
  }
}

@-ms-keyframes pulse {
  to {
    box-shadow: 0 0 0 8px rgba(232, 76, 61, 0);
  }
}

@keyframes pulse {
  to {
    box-shadow: 0 0 0 8px rgba(232, 76, 61, 0);
  }
}


.organization-chart-name-print {
  width: 180px;
  text-align: center;
  padding: 10px;
  word-break: break-word;
  background: #022245;
  border-radius: 4px;
  position: relative;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}

.organization-chart-name-print:nth-child(n + 2) {
  margin-top: 20px;
}



.organization-chart-name-print:nth-child(n + 2)::before {
  content: '';
  position: absolute;
  background-color: #022245;
  width: 180px !important;
  height: .5px;
  top: -10px;
  left: -90px;
  font-family: Times New Roman, serif;
}

.line-vertical-bottom {
  background: #022245;
  position: absolute;
  height: 10px;
  bottom: -10px;
  width: .5px;
}

.line-vertical-top {
  background: #022245;
  position: absolute;
  height: 10px;
  top: -10px;
  width: .5px;
}

.btn_export {
  background-color: #CBD63E;
  color: #022245;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 15px;
  line-height: 24px;

  i {
    color: #022245;
    margin-right: 6px;
  }

  img {
    width: 15px;
    height: 15px;
    margin-right: 6px;
  }
}

</style>
